
import ProductBlock from "../components/ProductBlock";
import React, {useEffect, useState} from "react";
import getAirtableData from "../product_data/itemData";
import Categories from "../components/Categories";
import ProductLoader from "../components/ProductLoader";

//Статический Json
import dataDefault from "../assets/items.json";


//ToDo: Создать фильтр товаров для подгрузки с api




function Home (){
    const [categoryID, setCategoryID] = useState(0)
    const [sortActive, setSortActive] = React.useState(0);
    const [isLoading, setIsLoading] = React.useState(false);
    const loadData = [...new Array(8)];
    const [data, setData] = useState(dataDefault)
    const [product, setProduct] = useState(null);


    console.log("loading1")

   
    const clickPopUp = (i) =>{
        setSortActive(i);
    }
    useEffect(()=>{
        const airtableDataPromise = new Promise((resolve, reject) => {
            getAirtableData()
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });

        airtableDataPromise
            .then((data) => {
                console.log(data)
                setProduct(data)
                setData(data);
                setIsLoading(true);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    },[isLoading])

    useEffect(() => {
        console.log(data)
        console.log("loading2");



        function filterCategory(product){
            return [...product.filter((item) => {
                return item.category == categoryID ;
            })];

        };
          function  filterSortCategory (product){

            switch (sortActive) {
                case 0: return [...product.sort((a,b) => a.rating - b.rating)]; break
                case 1: return [...product.sort((a,b) => a.price - b.price)]; break
                case 2: return [...product.sort((a, b) => {
                    const nameA = a.title.toUpperCase(); // ignore upper and lowercase
                    const nameB = b.title.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                })]; break
                default: return [...product];

            }
              }


        categoryID ? setData(filterCategory(product || data)) : setData(filterSortCategory(product || data));



    },[categoryID, sortActive]);

    return(

        <>

            <div className="content__top">
                <Categories value={categoryID} onClickCategory={(i) => setCategoryID(i)} sortValue={sortActive} clickPopUp={(i) => clickPopUp(i)} />
            </div>
            <div className="content__items">

                { isLoading ?
                    data.map((data) => (<ProductBlock key={data.id}  {...data} />
                    )) : loadData.map((_, index) =>  <ProductLoader key={index} /> ) }
            </div>
        </>
    )
}


export default Home;